// extracted by mini-css-extract-plugin
export default {"markerWrapper":"Marker_markerWrapper__KhJax","marker":"Marker_marker__czfY6"};